<template>
  <v-sheet
    height="100%"
    class="overflow-hidden"
    style="position: relative; margin-top:0px; border-radius:0; "
  >
    <v-row align="center" class="px-12" style="padding-right: 0px!important;">
      <!-- <v-col style="flex-grow: 0;">
        <v-icon style="float:left;" right @click="changePage">mdi-arrow-left</v-icon>
      </v-col>-->
      <v-col cols="9">
        <h4
          style="margin-left: 0px;font-size:28px; color:#777; font-weight:300; text-align:left; max-width: fit-content"
        >Espacios</h4>
      </v-col>
      <v-col cols="3">
        <!-- <v-dialog width="500"  v-model="deleteDialog" v-if="selected.length > 0">
            <template v-slot:activator="{ on }">
              <v-btn
              
                v-on="on"
                icon
                color="admiraFontGray"
                class="py-0 my-0"
                style="margin-left:-165px;"
              > <v-icon style="cursor: pointer; font-size:25px">mdi-delete</v-icon>
              </v-btn>
            </template>

            <v-card class="pl-5 pr-5">
              <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
              <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
                <p>¿Estás seguro que quieres eliminar este elemento?<br>Esta acción no se puede deshacer</p>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-col cols="6">
                    <v-btn
                      style="border-color: #fff;"
                      @click="deleteDialog = false"
                      rounded
                      depressed
                      outlined
                      small
                      width="100"
                    >Cancelar</v-btn>
                  </v-col>

                  <v-col cols="6">
                    <v-btn
                      @click="deleteMulti(selected)"
                      style="background: #679940;"
                      dark
                      rounded
                      depressed
                      outlined
                      small
                      width="100"
                    >Aceptar</v-btn>
                  </v-col>
                </v-card-actions>
              </v-col>
            </v-card>
        </v-dialog>-->
                        <!-- <v-btn
                  @click="addQueue"
                  fab
                  color="admiraGreen"
                  dark
                  small
                  style="float: right;margin-right: 50px;"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn> -->

                <!-- <v-btn
                 v-if="table == true"
                  @click="openLeftListSpaces"
                  color="#679940"
                  dark
                  icon
                  x-large
                  style="float:right;"
                >
                  <v-icon>mdi-office-building</v-icon>
                </v-btn> -->
                <v-btn
                  @click="seeMap"
                  color="#679940"
                  dark
                  icon
                  x-large
                  style="float:right; margin-right:20%"
                >
                  <v-icon>mdi-map</v-icon>
                </v-btn>
                 <v-btn
                  @click="seeTable"
                  color="#679940"
                  dark
                  icon
                  x-large
                  style="float:right;"
                >
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
      </v-col>
    </v-row>

    <v-divider />

    <router-view></router-view>

    <div class="ml-0 mr-0" style="width:100%">
      <div>
        <v-row class="align-center justify-center px-0">
          <v-col style="padding:0px"> 
            <!-- <div v-if="skeleton" class="px-5">
              <v-skeleton-loader class="mx-auto" max-width type="table-thead"></v-skeleton-loader>

            <v-skeleton-loader class="mx-auto" max-width type="table-row-divider@6" height="calc(100vh - 277px)"></v-skeleton-loader>-->

            <!-- <v-skeleton-loader class="mx-auto" max-width type="table-tfoot"></v-skeleton-loader>
            </div>-->

            <!-- @click:row="editQueue" -->

            <v-row               v-if="map == true">
              <v-col style="padding:0px">



                <SpacesMap></SpacesMap>

              </v-col>
            </v-row>
  <v-row  v-if="table == true" style="    padding-left: 50px;padding-right: 50px;
    ">
    <v-col>
<v-data-table
              mobile-breakpoint="0"
              @click:row="editQueue"
              v-model="selected"
              show-select
              :headers="headers"
              :items="allSpaces"
              :search="search"
              item-key="idSpace"
              class="elevation-0"
              style="color: #777; cursor:pointer; height: "
              sortBy="idSpace"
              update: sort-desc
            >

            <!-- <template v-slot:item.icon="{ item }">
                <v-icon v-if="item.type == 1" color="#679940">mdi-human-male-male</v-icon>
                <v-icon v-if="item.type == 2" color="#679940">mdi-ticket-outline</v-icon>
                <v-icon v-if="item.type == 3" color="#679940">mdi-ticket-confirmation</v-icon>
            </template>-->

            <!-- <template v-slot:item.type="{ item }">
                <p style="margin-bottom: -6px;" v-if="item.type == 1" >Fila</p>
                <p style="margin-bottom: -6px;" v-if="item.type == 2" >Tiquets</p>
                <p style="margin-bottom: -6px;" v-if="item.type == 3" >Multipuesto</p>
            </template>-->

            <!-- <template v-slot:item.Actions="{ item }">

                <v-menu offset-y  transition="slide-y-transition" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                    >
                      <v-icon dark>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item @click="editQueueRightMenu(item)">
                      <v-list-item-title style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 15px; margin-right: 5px;">mdi-pencil</v-icon>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item >
                        <v-dialog width="500"  v-model="deleteDialog">
                          <template v-slot:activator="{ on }">
                            <v-list-item-title v-on="on" style="cursor:pointer; font-size:12px; color:#9e9e9e"><v-icon style="font-size: 15px; margin-right: 5px;">mdi-delete</v-icon>Eliminar</v-list-item-title>

            </template>
              <v-card class="pl-5 pr-5">
                <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
                <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
                  <p>¿Estás seguro que quieres eliminar este elemento?<br>Esta acción no se puede deshacer</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-col cols="6">
                      <v-btn
                        style="border-color: #fff;"
                        @click="deleteDialog = false"
                        rounded
                        depressed
                        outlined
                        small
                        width="100"
                      >Cancelar</v-btn>
                    </v-col>

                    <v-col cols="6">
                      <v-btn
                        @click="deleteQueueRightMenu(item)"
                        style="background: #679940;"
                        dark
                        rounded
                        depressed
                        outlined
                        small
                        width="100"
                      >Aceptar</v-btn>
                    </v-col>
                  </v-card-actions>
                </v-col>
              </v-card>
            </v-dialog> 
                    </v-list-item>
                  </v-list>

                </v-menu>

            </template>-->
            </v-data-table> 
    </v-col>
  </v-row>
            

            <v-navigation-drawer
             v-if="table == true"
              :disable-route-watcher="true"
              :value="showLeftMenu"
              absolute
              :clipped="$vuetify.breakpoint.smAndUp"
              width="419"
              style="height: calc(100vh - 50px);z-index:100"
              class="elevation-4"
              left
              stateless
            >
              <LeftMenuAddNewSpace v-if="LeftMenuAddNewSpace" />
            </v-navigation-drawer>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";
import RightMenuAddNewQueue from "@/components/RightMenuAddNewQueue.vue";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
import LeftMenuAddNewSpace from "@/components/LeftMenuAddNewSpace.vue";
import SpacesMap from "@/components/SpacesMap.vue";

export default {
  name: "Queues",
  components: {
    RightMenuAddNewQueue,
    RightMenuEditQueue,
    deleteDialog: false,
    LeftMenuAddNewSpace,
    SpacesMap
  },
  data() {
    return {
      table: true,
      map: false,
      deleteDialog: false,
      search: "",
      skeleton: true,
      selected: [],
      arrProposalData: []
    };
  },
  computed: {
    ...mapState("app", ["actualProject"]),

    ...mapState("queues", [
      "LeftMenuAddNewSpace",
      "showLeftMenu",
      "spaceSelected",
      "allQueues",
      "RightMenuAddNewQueue",
      "showRightMenu",
      "allSpaces",
      "RightMenuEditQueue"
    ]),

    headers() {
      return [{ text: "Nombre", value: "name", align: "start" }];
    }
  },
  methods: {
    ...mapMutations("queues", [
      "openLeftMenuMutation",
      "LeftMenuTrueNewSpace",
      "setActualSpaceMutation",
      "openRightMenuMutation",
      "closeRightMenuMutation"
    ]),
    ...mapActions("queues", [
      "getAllQueues",
      "getAllSpaces",
      "getAllResouces",
      "editQueueStore",
      "showRightMenuProposalStore",
      "hideRightMenuProposalStore",
      "rightMenuTrueNewDeviceTableStore",
      "rightMenuTrueNewDeviceTableStore2",
      "deleteMultipleQueues",
      "deleteOneQueueStore"
    ]),
    seeMap(){
      this.table = false;
      this.map = true;
    },
    seeTable(){
      this.table = true;
      this.map = false;
    },
    goToCampaignAs(role) {
      this.viewAsClient = true;
    },
    async editQueue(campaign) {
      const mobileCheck = {
        Android: () => navigator.userAgent.match(/Android/i),
        BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
        iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
        Opera: () => navigator.userAgent.match(/Opera Mini/i),
        Windows: () => navigator.userAgent.match(/IEMobile/i),
        any: function() { return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows()); }
      };

      await this.setActualSpaceMutation(campaign);
      if (mobileCheck.any() != null) {
        this.$router.push({
          name: "ResumeSpaceMobile",
          params: { idQueue: campaign.idSpace }
        });
      } else {
        this.$router.push({
          name: "ResumeSpace",
          params: { idQueue: campaign.idSpace }
        });
      }
    },
    async openLeftListSpaces() {
      this.openLeftMenuMutation();
      await this.LeftMenuTrueNewSpace();
    },
    editQueueRightMenu(data) {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore2(data);
    },
    deleteQueueRightMenu(data) {
      this.deleteOneQueueStore(data);
      this.closeRightMenuMutation();
      let idProject = this.actualProject.id;
      this.getAllQueues(idProject);
      this.getAllSpaces(idProject);
      this.getAllResouces(idProject);
    },
    deleteMulti(data) {
      let idsQueues = [];
      data.forEach(element => {
        idsQueues.push(element.idQueue);
      });
      this.deleteMultipleQueues(idsQueues);
      let idProject = this.actualProject.id;
      this.getAllQueues(idProject);
      this.getAllSpaces(idProject);
      this.getAllResouces(idProject);
      this.deleteDialog = false;
      this.selected = [];
    },
    changePage() {
      const mobileCheck = {
        Android: () => navigator.userAgent.match(/Android/i),
        BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
        iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
        Opera: () => navigator.userAgent.match(/Opera Mini/i),
        Windows: () => navigator.userAgent.match(/IEMobile/i),
        any: function() { return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows()); }
      };
      if (mobileCheck.any() != null) {
        this.$router.push({
          name: "ResumeSpaceMobile"
        });
      } else {
        this.$router.push({
          name: "ResumeSpace"
        });
      }
    }
  },

  async created() {
    let idProject = this.actualProject.id;
    await this.getAllSpaces(idProject);
    await this.getAllResouces(idProject);
    await this.getAllQueues(idProject);
  },
  destroyed() {}
};
</script>

<style scoped>
a {
  text-decoration: none;
}
>>> .v-data-table__wrapper {
  height: calc(100vh - 207px);
  overflow: auto;
}
>>> th {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/views/desktop/ListSpaces.vue